export default __webpack_public_path__ + "static/media/cost-efficent.3749816c.jpg";